import {useEffect} from 'react';

import {Center} from '@mantine/core';
import {PlatformLoader} from '@flexinet/ui-components';
import {pushAnalyticsEvent} from '@flexinet/analytics-components';
import {signOut} from 'aws-amplify/auth';

export const SignOutPage = () => {
    useEffect(() => {
        // FNP-1685: a resolved signOut() may have started Amplify's own logout
        // navigation, so leave for '/' only after a delay; if it navigated, the
        // page has unloaded and the timer never fires. It also resolves WITHOUT
        // navigating when there is no OAuth session (D14b). A rejection leaves
        // at once rather than sitting on the loader.
        const doSignOut = async () => {
            try {
                await signOut();
                pushAnalyticsEvent('sign_out');
                setTimeout(() => {
                    window.location.href = '/';
                }, 3000);
            } catch (error) {
                console.error('Sign out did not complete cleanly', error);
                window.location.href = '/';
            }
        };

        doSignOut();
    }, []);

    return (
        <Center>
            <PlatformLoader/>
        </Center>
    );
};
